// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"424":"4ecf317cf4f9a6ed","754":"b822323cc4d90994","1163":"a7136bbb100e87be"}[chunkId] + ".css";
};